import sha1 from 'sha1';
import { getExternal } from '@nbx/frontend-helpers/fetch-api';

const baseUrl = 'https://api.pwnedpasswords.com';

const HaveIBeenPwned = {
  isPasswordPwned: password => {
    try {
      const hash = sha1(password);
      return getExternal(`${baseUrl}/range/${hash.slice(0, 5)}`, 'text/plain').then(result => {
        if (result.includes(hash.slice(5).toUpperCase())) {
          return true;
        }
        return false;
      });
    } catch (error) {
      console.error(`HIBP error while checking password ${password}:`, error); // eslint-disable-line
      return false;
    }
  }
};

export default HaveIBeenPwned;
